/**
 * ID role v nastavení práv "bez uvedení role"
 * */
export const ROLELESS_ROLE_ID: string = "0";
